"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GlobalCounter {
    static next() {
        let counter = window.__FMK_online_Id_Counter__;
        if (!counter) {
            let i = 0;
            counter = function () {
                return `fmko-${i++}`;
            };
            window.__FMK_online_Id_Counter__ = counter;
        }
        return counter();
    }
}
exports.default = GlobalCounter;
//# sourceMappingURL=GlobalCounter.js.map